export const getLandingViewerKey = (isAuthenticated, userId) =>
  isAuthenticated && userId ? userId : 'guest';

export const hasLandingViewerChanged = (currentViewerKey, nextViewerKey) =>
  currentViewerKey !== nextViewerKey;
